import React from "react";
import { NavLink } from "react-router-dom";

const linkStyle = ({ isActive }) => ({
  color: "#fff",
  textDecoration: isActive ? "underline" : "none",
  fontWeight: 600,
});

export default function Header({ rightActions, session, onSignOut }) {
  return (
    <header style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
      <div style={{ display: "flex", gap: 16, alignItems: "baseline" }}>
        <h1 style={{ margin: 0, fontSize: 24 }}>PeekBoard</h1>
        <nav style={{ display: "flex", gap: 12 }}>
          <NavLink to="/" end style={linkStyle}>Dashboard</NavLink>
          <NavLink to="/avg" style={linkStyle}>Calculator</NavLink>
        </nav>
      </div>

      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        {rightActions}
        {session ? (
          <button
            onClick={onSignOut}
            style={{ background: "#2a2a2a", color: "#fff", borderRadius: 10, padding: "10px 12px", border: "1px solid #3a3a3a" }}
          >
            Sign out
          </button>
        ) : (
          <NavLink
            to="/login"
            style={{ background: "#2a2a2a", color: "#fff", borderRadius: 10, padding: "10px 12px", border: "1px solid #3a3a3a", textDecoration: "none", fontWeight: 600 }}
          >
            Sign in
          </NavLink>
        )}
      </div>
    </header>
  );
}
